import {Component, Input} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {Router} from "@angular/router";
declare let gtag: Function;

@Component({
  selector: 'app-authorization-required-modal',
  templateUrl: './authorization-required-modal.component.html',
  styleUrls: ['./authorization-required-modal.component.scss']
})
export class AuthorizationRequiredModalComponent {

  @Input() title = "Authorisation required";
  @Input() body = "To use this functionality you need to be logged in. Please click on the login or the sign up button.";
  @Input() usingForApplication = false;
  constructor(public activeModal: NgbActiveModal, private router: Router) {}

  login() {

    if(this.usingForApplication && typeof gtag !== 'undefined') {
      gtag('event', 'login_to_apply', {
        'event_category': 'engagement',
        'event_label': 'User clicked login to apply for a job'
      })
    }

    this.router.navigate(['/account/sign-in'], { queryParams: { returnUrl: this.router.url } });
    this.activeModal.close();
  }

  signUp() {
    if(this.usingForApplication && typeof gtag !== 'undefined') {
      gtag('event', 'sign_up_to_apply', {
        'event_category': 'engagement',
        'event_label': 'User clicked sign up to apply for a job'
      })
    }

    this.router.navigate(['/account/sign-up/individual'], { queryParams: { returnUrl: this.router.url } });
    this.activeModal.close();
  }

  cancel() {

    if(this.usingForApplication && typeof gtag !== 'undefined') {
      gtag('event', 'cancel_authorization_to_apply', {
        'event_category': 'engagement',
        'event_label': 'User cancelled authorization modal when applying for a job'
      });
    }
    this.activeModal.dismiss('cancel click')
  }
}
